import { Tooltip } from 'antd';
import { AppBox } from './boxes/AppBox';
import { handleTranslation } from '../lib/util/helpers';

export function AppTooltip({ tile, text, htmlText, ...rest }) {
  return <AppBox {...rest} as={Tooltip} title={htmlText || handleTranslation(text)} />;
}
